<template lang="pug">
.spm(v-if="link != null")
  .spmTitle 快速連結
  .spmTop
    .spm1
      a.f1window(:href="link[0].url" target="_blank")
        .block {{ link[0].title }}
        Flower11
      a.f2window(:href="link[1].url" target="_blank")
        .block {{ link[1].title }}
        Flower12 
    .spm2
      a.f3window( :href="link[2].url" target="_blank")
        .block {{ link[2].title }}
        Flower21
      a.f4window(:href="link[3].url" target="_blank")
        .block {{ link[3].title }}
        Flower22 

  .spmBottom
    .spm3
      a.f5window(:href="link[4].url" target="_blank")
        .block {{ link[4].title }}
        Flower31
      a.f6window(:href="link[5].url" target="_blank")
        .block {{ link[5].title }}
        Flower32
    .spm4
      a.f7window(:href="link[6].url" target="_blank")
        .block {{ link[6].title }}
        Flower41
      a.f8window(:href="link[7].url" target="_blank")
        .block {{ link[7].title }}
        Flower42
    
</template>

<script>
import Flower11 from '@/components/Flower/Flower11'
import Flower12 from '@/components/Flower/Flower12'
import Flower21 from '@/components/Flower/Flower21'
import Flower22 from '@/components/Flower/Flower22'
import Flower31 from '@/components/Flower/Flower31'
import Flower32 from '@/components/Flower/Flower32'
import Flower41 from '@/components/Flower/Flower41'
import Flower42 from '@/components/Flower/Flower42'
export default {
  props: {
    link: {
      type: Array,
      default: () => []
    }
  },
  components: { Flower11, Flower12, Flower21, Flower22, Flower31, Flower32, Flower41, Flower42 },
}
</script>

<style lang="sass" scoped>
@import '@/assets/style.sass'
.spm
  width: 95%
  height: 57vw
  box-sizing: border-box
  background: url('../assets/spblock.png')
  +bgcon
  background-position: 0 0
  background-size: 100% auto
  position: relative
  margin-top: 2%
  +flexcolumn
  +phone
    background: url('../assets/spp.png')
    +bgcon
    background-position: 0 0
    background-size: 100% auto
    // +bb
    height: 162vw
    padding: 7.9% 0 0 0
    +ie
      padding: 7.9% 0 8% 0
  .spmTitle
    width: 20%
    font-size: 3.5vw
    text-align: center
    font-weight: 800
    color: #878787
    margin-left: -10%
    left: 50%
    top: 0.5%
    // +bb
    position: absolute
    +phone
      width: 20%
      font-size: 3.5vw
      margin-left: -10%
      left: 50%
      top: 1%


    
    



  .spmTop
    width: 100%
    height: 50%
    +flexrow
    // +bb
    border-color: #878787
    // margin-top: 2%
    // box-sizing: border-box
    +phone
      +flexcolumn
    .spm1
      +size(50%, 100%)
      +bgcon
      background-position: 0 0
      border-color: #878787
      position: relative
      box-sizing: border-box
      +phone
        +size(85.5%, 100%)
        margin-left: 7.5%

      .f1window
        position: absolute
        margin-top: 17%
        margin-left: 17%
        width: 40%
        height: 67%
        +bb
        border-color: #DADBDB
        transition: 0.5s
        cursor: pointer
        +phone
          margin-top: 5%
          margin-left: 5%
          height: 85%

      .f2window
        position: absolute
        margin-top: 17%
        margin-left: 62%
        width: 40%
        height: 67%
        border-color: #DADBDB
        cursor: pointer
        +phone
          height: 85%
          margin-top: 5%
          margin-left: 52%
    .spm2
      border-color: #878787
      box-sizing: border-box
      +size(50%, 100%)
      +bgcon
      background-position: 0 0
      position: relative
      +phone
        +size(85.5%, 100%)
        margin-left: 7.5%

      .f3window
        position: absolute
        margin-top: 17%
        margin-left: 7%
        width: 40%
        height: 67%
        +bb
        border-color: #DADBDB
        cursor: pointer
        +phone
          height: 85%
          margin-top: 3%
          margin-left: 5%

        

      .f4window
        position: absolute
        margin-top: 17%
        margin-left: 52.5%
        width: 40%
        height: 67%
        +bb
        border-color: #DADBDB
        cursor: pointer
        +phone
          height: 85%
          margin-top: 3%
          margin-left: 52%


  .spmBottom
    width: 100%
    height: 50%
    +flexrow
    border-color: #878787
    +phone
      +flexcolumn

    .spm3
      +size(50%, 100%)
      +bgcon
      border-color: #878787
      box-sizing: border-box
      background-position: 0 0
      position: relative
      +phone
        +size(85%, 100%)
        margin-left: 7.5%
        box-sizing: initial
      .f5window
        position: absolute
        margin-top: 2%
        margin-left: 17%
        width: 40%
        height: 67%
        +bb
        border-color: #DADBDB
        cursor: pointer
        box-sizing: border-box
        +phone
          height: 85%
          margin-left: 5%
          margin-top: 2%
        

      .f6window
        position: absolute
        margin-top: 2%
        margin-left: 62%
        width: 40%
        height: 67%
        +bb
        border-color: #DADBDB
        cursor: pointer
        box-sizing: border-box
        +phone
          height: 85%
          margin-left: 52%
          margin-top: 2%

    .spm4
      +size(50.1%, 100%)
      +bgcon
      border-color: #878787
      box-sizing: border-box
      background-position: 0 0
      position: relative
      +phone
        +size(85.5%, 100%)
        margin-left: 7.5%
        box-sizing: initial
      .f7window
        position: absolute
        margin-top: 2%
        margin-left: 7%
        width: 40%
        height: 67%
        +bb
        border-color: #DADBDB
        cursor: pointer
        box-sizing: border-box
        +phone
          height: 85%
          margin-top: 0%
          margin-left: 5%


      .f8window
        position: absolute
        margin-top: 2%
        margin-left: 52%
        width: 40%
        height: 67%
        // z-index: 12
        +bb
        border-color: #DADBDB
        cursor: pointer
        box-sizing: border-box
        +phone
          height: 85%
          margin-left: 52%
          margin-top: 0%

.block
  position: absolute
  font-size: 18px
  letter-spacing: 1.5px
  z-index: 3
  background-color: rgba(#EEE, 0.7)
  width: 100%
  padding: 0.1vw 0.15vw
  bottom: 0
  line-height: 30px
  border-top: solid 3px #999
  @media all and (max-width: 636px)
    font-size: 15px
    line-height: 25px
  @media all and (max-width: 615px)
    font-size: 18px
    line-height: 30px
  @media all and (max-width: 377px)
    font-size: 15px
    line-height: 25px
  @media all and (max-width: 316px)
    font-size: 13px
    line-height: 20px
  @media all and (max-width: 281px)
    font-size: 10px
    line-height: 20px
        
</style>


// WEBPACK FOOTER //
// src/components/SpecialM.vue